import { computed, type ComputedRef } from 'vue';
import { useRoute } from 'vue-router';

/**
 * Best-effort current-project resolver. The Copilot scopes its proposal
 * tools to a project, so it needs to know which one is in view.
 *
 * Today we read it from the route params (`/projects/:projectId/...`,
 * `/scenarios/:scenarioId` is not yet wired here — TODO when we want
 * scenario-page Copilot to act on the parent project too).
 */
export function useCurrentProjectId(): ComputedRef<string | null> {
  const route = useRoute();
  return computed(() => {
    const raw = route.params.projectId;
    if (typeof raw === 'string' && raw.length > 0) return raw;
    return null;
  });
}
